<template>
    <rkm-modal
        persistent
        ref="Modal"
        title="Protocolo de agendamento"
    >
        <rkm-form
            v-if="loaded"
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="form.opcoesRetiradaProtocoloAgendamento"
                        @change="handleRetiradaChange"
                        label="Retirada do protocolo"
                        text-field="nome"
                        v-model="model.opcaoRetiradaProtocoloAgendamentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col v-if="model.opcaoRetiradaProtocoloAgendamentoId === enums.opcaoRetiradaProtocoloAgendamento.RETIRADO">
                    <rkm-form-input
                        :validations="validations.nomePessoaRetiradaProtocoloAgendamento"
                        label="Nome de quem retirou o protocolo"
                        uppercase
                        v-model="model.nomePessoaRetiradaProtocoloAgendamento"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                v-if="!hideCancel"
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Enums.
import opcaoRetiradaProtocoloAgendamento from '@/enums/regulacao/opcaoRetiradaProtocoloAgendamento'

// Mixins.
import { repository, error, object, stringCase } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                nomePessoaRetiradaProtocoloAgendamento: { required: true, max: 150 },
            }
        }
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
        }
    },
    data: () => ({
        solicitacao: null,
        loaded: false,
        form: null,
        model: null,
        enums: { opcaoRetiradaProtocoloAgendamento },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(solicitacao) {

            this.loaded = false
            this.solicitacao = solicitacao

            this.load()
            this.$refs.Modal.show()
        },
        handleRetiradaChange(id) {

            if (id === this.enums.opcaoRetiradaProtocoloAgendamento.RETIRADO) {

                if (!this.model.nomePessoaRetiradaProtocoloAgendamento) {

                    this.model.nomePessoaRetiradaProtocoloAgendamento = this.form.pacienteNome
                }
            }
            else {

                this.model.nomePessoaRetiradaProtocoloAgendamento = null
            }
        },
        load() {

            this.setLoading()

            this.repositories.fila.editProtocoloAgendamento(this.solicitacao.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                this.setLoading()

                this.repositories.fila.updateProtocoloAgendamento(this.solicitacao.id, this.prepareData())
                    .then(({ data }) => {

                        this.$emit('save', {
                            opcaoRetiradaProtocoloAgendamentoId: data.opcaoRetiradaProtocoloAgendamentoId,
                            nomePessoaRetiradaProtocoloAgendamento: data.nomePessoaRetiradaProtocoloAgendamento
                        })

                        this.$refs.Modal.hide()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        prepareData() {

            const data = this.clone(this.model)

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, error, object, stringCase],
    props: {
        hideCancel: { type: Boolean, default: false },
    }
}
</script>